function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Cube from '@/components/icons/lord/Cube';
import { getSSOToken } from '@/actions/AuthActions';
import { HTTPError } from '@/utils/api';
import { WebRoutes } from '@/utils/constants';
import useAuthenticationStore from '@/stores/AuthenticationStore';
import { useNavigate } from 'react-router';
import { LordIconSizes } from '@/types/client';
import serializePath, { sanitizePathname } from '@/utils/url';
import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import Notice from '../Notice';
import useLoginRedirect from '@/hooks/useLoginRedirect';
import { useShallow } from 'zustand/react/shallow';
var POLLING_INTERVAL = 2000;
export default function LoginSSO() {
    var navigate = useNavigate();
    var intl = useIntl();
    var _useAuthenticationStore = useAuthenticationStore(useShallow(function(state) {
        return {
            redirectPath: state.redirectPath,
            setAccessToken: state.setAccessToken,
            setUnverified2FA: state.setUnverified2FA,
            setRedirectPath: state.setRedirectPath
        };
    })), redirectPath = _useAuthenticationStore.redirectPath, setAccessToken = _useAuthenticationStore.setAccessToken, setUnverified2FA = _useAuthenticationStore.setUnverified2FA, setRedirectPath = _useAuthenticationStore.setRedirectPath;
    var redirectLogin = useLoginRedirect(redirectPath);
    React.useEffect(function() {
        var checkSSOToken = function checkSSOToken() {
            return _checkSSOToken.apply(this, arguments);
        };
        var interval = null;
        function _checkSSOToken() {
            _checkSSOToken = _async_to_generator(function() {
                var _ref, accessToken, unverified2FA, _sanitizePathname, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                getSSOToken()
                            ];
                        case 1:
                            _ref = _state.sent(), accessToken = _ref.accessToken, unverified2FA = _ref.unverified2FA;
                            setUnverified2FA(unverified2FA);
                            setAccessToken(accessToken);
                            if (unverified2FA) {
                                navigate(serializePath(WebRoutes.TWO_FACTOR, {
                                    return_to: redirectPath
                                }));
                            } else {
                                setRedirectPath(null);
                                ;
                                navigate((_sanitizePathname = sanitizePathname(redirectPath)) !== null && _sanitizePathname !== void 0 ? _sanitizePathname : WebRoutes.DASHBOARD);
                            }
                            if (interval != null) {
                                clearInterval(interval);
                                interval = null;
                            }
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            if (_instanceof(error, HTTPError) && error.statusCode !== 404) {
                                return [
                                    2
                                ];
                            }
                            redirectLogin();
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return _checkSSOToken.apply(this, arguments);
        }
        interval = setInterval(function() {
            checkSSOToken();
        }, POLLING_INTERVAL);
        return function() {
            if (interval != null) {
                clearInterval(interval);
                interval = null;
            }
        };
    }, [
        setAccessToken,
        redirectPath,
        navigate,
        redirectLogin,
        setUnverified2FA,
        setRedirectPath
    ]);
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "F4uo6q",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Logging in"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Notice, {
                description: intl.formatMessage({
                    id: "xllyRV",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Continue on your browser to login."
                        }
                    ]
                }),
                beforeElement: /*#__PURE__*/ _jsx(Cube, {
                    trigger: "loop",
                    size: LordIconSizes.MEDIUM
                })
            })
        ]
    });
}
